import ensureArray from './ensureArray';
export default function arrayLength(maybeArray) {
    return ensureArray(maybeArray).length;
}
